/* Reveal a changed gallery image after a deliberate mobile material selection. */
(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 767px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-rd-mobile-fabric-scroll]').forEach(swatch => {
    if (swatch.dataset.scrollReady) return;
    const product = swatch.closest('.proBoxPrimary');
    const gallery = product && product.querySelector('.feature-slider');
    if (!gallery || product.closest('.rd-pro-overview')) return;
    swatch.dataset.scrollReady = 'true';
    const currentImageId = () => {
      const image = gallery.querySelector('img.slick-current[data-image-id], .slick-current img[data-image-id]');
      return image && image.getAttribute('data-image-id');
    };
    swatch.addEventListener('change', event => {
      const input = event.target;
      if (!event.isTrusted || !mobile.matches || !input.matches('input[type="radio"]') || !input.checked || input.disabled) return;
      // Capture the current image before the existing variant handlers update Slick.
      const previousImageId = currentImageId();
      window.requestAnimationFrame(() => {
        if (!mobile.matches || !input.checked || !gallery.isConnected) return;
        const selectedImageId = currentImageId();
        if (!previousImageId || !selectedImageId || previousImageId === selectedImageId) return;
        let offset = 16;
        const header = document.querySelector('#velaHeader');
        if (header) {
          const style = window.getComputedStyle(header);
          if (style.position === 'fixed' || style.position === 'sticky') {
            offset += Math.max(0, header.getBoundingClientRect().bottom);
          }
        }
        window.scrollTo({
          top: Math.max(0, window.scrollY + gallery.getBoundingClientRect().top - offset),
          behavior: reducedMotion.matches ? 'instant' : 'smooth'
        });
      });
    }, true);
  });
})();
